import {getCurrentYear} from '../../utils/commons'
import TheBestReviewsLogo from './logo'
import {theBestReviewsStyles} from './styles'

const baseConfig = {
  domainName: 'thebestreviews' as const,
  domainType: 'brg' as const,
  camelCaseUrl: 'TheBestReviews.guide',
  siteName: 'The Best Reviews Guide',
  logo: <TheBestReviewsLogo />,
  favicon: '/favicons/bestreviews.png',
  styles: theBestReviewsStyles,
}

const localeConfigs = {
  us: {
    measurementId: 'G-ZSYVMREZ37',
    title: (category: string, count: string) =>
      `${count} Best ${category} ${getCurrentYear()} in the US | There's One Clear Winner | TheBestReviews.guide`,
    description: (_category?: string, _count?: string) =>
      `TheBestReviews.guide analyzes thousands of articles and customer reviews to find the top-rated products at today's lowest prices. Best products, best offers.`,
  },
}

export const createConfig = (locale: string = 'us') => {
  const localeConfig = localeConfigs[locale as keyof typeof localeConfigs] || localeConfigs.us
  return {
    ...baseConfig,
    ...localeConfig,
  }
}
